export const idtype = {
    ID: 1,
    UUID: 2,
}
